module.exports = __webpack_public_path__ + "img/shape5.78ef6994.svg";